import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

import ShippingType from "@/types/ShippingType";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface ShippingTypeInfo {
  shippingType: ShippingType;
}

@Module
export default class ShippingTypeModule extends VuexModule implements ShippingTypeInfo {
  shippingType = {} as ShippingType;

  @Mutation
  [Mutations.SET_SHIPPINGTYPE](shippingType) {
    this.shippingType = shippingType;
  }

  @Action
  [Actions.SHIPPINGTYPE_LIST]() {
    return ApiService.get("shippingType")
      .then(({ data }) => {
        this.context.commit(Mutations.SET_SHIPPINGTYPE, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.ADD_SHIPPINGTYPE](args) {
    return ApiService.post("shippingType", args).then(({ data }) => {
      if (!data.success) {
        return data;
      } else {
        //this.context.commit(Mutations.SET_SIZE_SET, data);
        return data;
      }
    });
  }

  @Action
  [Actions.UPDATE_SHIPPINGTYPE](args) {
    return ApiService.put("shippingType", args).then(({ data }) => {
      if (!data.success) {
        return data;
      } else {
        //this.context.commit(Mutations.SET_SIZE_SET, data);
        return data;
      }
    });
  }

  @Action
  [Actions.REMOVE_SHIPPINGTYPE](id) {
    return ApiService.delete("shippingType/" + id + "")
      .then(({ data }) => {
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
        return response;
      });
  }
}
